import { render, staticRenderFns } from "./mySalary.vue?vue&type=template&id=8d2952d2&scoped=true&"
import script from "./mySalary.vue?vue&type=script&lang=js&"
export * from "./mySalary.vue?vue&type=script&lang=js&"
import style0 from "./mySalary.vue?vue&type=style&index=0&id=8d2952d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2952d2",
  null
  
)

export default component.exports